import styled, { css } from 'styled-components';
import { replace } from 'lodash';
import { device } from '../../../utils/breakpoints';
import { FlexContainer } from '../../layouts/Wrapper/Base.components';

const Grid = styled(FlexContainer)`
    display: flex;

    ${({ flex, noFlex }) => !noFlex && css`
        flex: ${flex || '1'};
    `};

    ${props => props.debug && `
        border: 1px solid black;
    `}

    flex-wrap: ${({ noWrap }) => noWrap ? 'nowrap' : 'wrap'};
`;

const Row = styled(Grid)`
    flex-direction: row;

    ${({ margin, mT = '0', mR = '0', mB = '0', mL = '0', mX, mY }) => `
        margin: ${margin || mY || mT}px ${margin || mX || mR}px ${margin || mY || mB}px ${margin || mX || mL}px;
    `}

    ${({ height }) => height && css`min-height: ${replace(height, 'px', '')}px;`}
    ${({ padding }) => padding && css`padding: ${padding};`}
    ${({ border }) => border && css`border: ${border};`}
    ${({ borderRadius }) => borderRadius && css`border-radius: ${replace(borderRadius, 'px', '')}px;`}
`;

const Column = styled(Grid)`
    flex-direction: ${({ direction = 'column' }) => direction};

    ${({ margin, mT = '0', mR = '0', mB = '0', mL = '0', mX, mY }) => `
        margin: ${margin || mY || mT}px ${margin || mX || mR}px ${margin || mY || mB}px ${margin || mX || mL}px;
    `}
`;

const Box = styled(Grid)`
    ${({ width = [], setDevices = {} }) => {
        const breakpoints = {
            ...device,
            ...setDevices
        };
        const [ mobile = '100%', tablet = '50%', laptop = '20%', desktop ] = width;
        return `
            min-width: ${mobile};
            ${mobile => mobile && `max-width: ${mobile};`}
            
            @media ${breakpoints.tablet} {
                min-width: ${tablet};
                max-width: ${tablet};
            }
            
            @media ${breakpoints.laptop} {
                min-width: ${laptop};
                max-width: ${laptop};
            }

            @media ${breakpoints.desktop} {
                min-width: ${desktop || laptop};
                max-width: ${desktop || laptop};
            }
        `;
    }}
    
    ${props => props.debug && `
        border: 1px solid black;
        background-color: gray;
    `}
`;

export { Row, Column, Box };
